import { render, staticRenderFns } from "./globalLoading.vue?vue&type=template&id=07a92012&scoped=true"
import script from "./globalLoading.vue?vue&type=script&lang=js"
export * from "./globalLoading.vue?vue&type=script&lang=js"
import style0 from "./globalLoading.vue?vue&type=style&index=0&id=07a92012&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07a92012",
  null
  
)

export default component.exports